import {
  PORT_LIST_GET_SUCCESS,
  PORT_GET_SUCCESS,
  PORT_CREATE_SUCCESS,
  PORT_UPDATE_SUCCESS,
  PORT_UPDATE_ERROR,
  PORT_DELETE_SUCCESS,
  PORT_DELETE_ERROR,
  PORT_LIST_GET_IN_PROGRESS,
  PORT_LIST_GET_ERROR,
  PORT_SELECT_SUCCESS,
  PORT_LIST_GET_REQUEST,
} from 'src/store/port/actions'
import { getIdsFromList, getByIdFromList } from 'src/utils/store'

export const getInitialState = {
  status: null,
  data: null,
  error: null,
  byId: null,
  statusById: null,
  errorById: null,
  selected: null,
}

export const reducer = (state = getInitialState, action) => {
  const { type, payload } = action
  const { uuid } =
    typeof payload === 'string' ? { uuid: payload } : payload || {}

  switch (type) {
    case PORT_LIST_GET_REQUEST:
    case PORT_LIST_GET_IN_PROGRESS:
      return {
        ...state,
        status: type,
      }
    case PORT_LIST_GET_ERROR:
      return {
        ...state,
        error: action.error || payload,
        status: type,
      }
    case PORT_LIST_GET_SUCCESS:
      return {
        ...state,
        status: type,
        data: getIdsFromList(payload),
        byId: getByIdFromList(payload),
        statusById: getIdsFromList(payload).reduce(
          (status, id) => ({
            ...status,
            [id]: type,
          }),
          {}
        ),
        errorById: {},
      }
    case PORT_GET_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: data.indexOf(uuid) > -1 ? data : [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case PORT_CREATE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case PORT_UPDATE_SUCCESS: {
      const { byId, statusById, ...restState } = state
      return {
        ...restState,
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case PORT_UPDATE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: payload,
        },
      }
    }
    case PORT_DELETE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      delete byId[uuid]
      return {
        ...restState,
        data: data.filter((id) => id !== uuid),
        byId: { ...byId },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case PORT_DELETE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: payload,
        },
      }
    }
    case PORT_SELECT_SUCCESS:
      return {
        ...state,
        selected: uuid,
      }
    default:
      return state
  }
}

export default reducer
